import { createAsyncThunk } from '@reduxjs/toolkit';
import { iStateMessage } from '@/customTypes/GenericReduxTypes';
import { iGenericResponse } from '@/customTypes/CommonServiceTypes';
import { curryGetThunkName } from '@/projectUtils/ReduxUtil';
import { httpStatusCodes } from '@/customTypes/NetworkTypes';
import { PoListService } from '@/services/api/cresivoxServer';

import { iPurchaseOrderListItem, REDUCER_NAME } from './Types';

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const getPurchaseOrderList = createAsyncThunk<
  iGenericResponse<iPurchaseOrderListItem | null> | null,
  void,
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName('purchaseOrderList'),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, { rejectWithValue }) => {
    try {
      const response = await PoListService.getPurchaseOrderList();

      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                httpStatusCode,
                data: data.data,
                message,
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: 'No response received',
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: 'Something went wrong',
      });
    }
  }
);
